export default __webpack_public_path__ + "static/media/Deceiver's Gloves of the Dusk Rebellion.328fd8f1.jpg";